import React, { useContext } from 'react'
import { Link } from 'react-router-dom'

import { LanguageContext } from '../../context/langContext'
import { languages } from '../../languages/languages'
import './EmptyPage.scss'

const EmptyPage = () => {
  const { language } = useContext(LanguageContext)

  return (
    <div className="EmptyPage">
      <div className="EmptyPage__Top">
        <h2>{languages[language].emptyPage.nothingToDisplay}</h2>
        <Link to="/allbooks">
          {languages[language].emptyPage.checkoutSomeBooks}
        </Link>
        <Link to="/">{languages[language].homePage}</Link>
      </div>
      <svg
        version="1.1"
        id="Layer_1"
        x="0px"
        y="0px"
        viewBox="0 0 512 512"
        className="EmptyPage__SVG"
      >
        <g>
          <g>
            <path
              d="M487.689,85.333H353.399l-8.533-8.533l5.009-5.009c2.79-2.782,3.302-7.117,1.254-10.479
            c-2.057-3.362-6.144-4.881-9.89-3.678L256,84.906L45.269,17.467c-2.594-0.819-5.436-0.367-7.629,1.237
            c-2.21,1.604-3.507,4.164-3.507,6.895v59.733h-9.822C10.906,85.333,0,96.238,0,109.644v360.969
            c0,13.406,10.906,24.32,24.311,24.32h463.377c13.406,0,24.311-10.914,24.311-24.32V109.644
            C512,96.238,501.094,85.333,487.689,85.333z M77.559,128.733c1.749-4.378,6.716-6.528,11.102-4.744l59.588,23.919
            c4.369,1.749,6.494,6.724,4.736,11.085c-1.34,3.337-4.54,5.359-7.919,5.359c-1.067,0-2.133-0.188-3.183-0.614l-59.58-23.919
            C77.926,138.069,75.802,133.094,77.559,128.733z M24.311,477.866c-3.994,0-7.245-3.251-7.245-7.253V109.644
            c0-4.002,3.251-7.245,7.245-7.245h9.822v315.733c0,3.703,2.398,6.997,5.931,8.124l161.28,51.61H24.311z M221.175,382.882
            c-1.271,3.439-4.531,5.572-8.004,5.572c-0.981,0-1.98-0.162-2.953-0.521l-127.693-47.13c-4.42-1.63-6.682-6.545-5.052-10.965
            c1.63-4.42,6.545-6.656,10.957-5.052l127.693,47.13C220.544,373.546,222.805,378.453,221.175,382.882z M221.175,331.682
            c-1.271,3.439-4.531,5.572-8.004,5.572c-0.981,0-1.98-0.162-2.953-0.521l-127.693-47.13c-4.42-1.63-6.682-6.545-5.052-10.965
            c1.63-4.42,6.545-6.665,10.957-5.052l127.693,47.13C220.544,322.346,222.805,327.253,221.175,331.682z M221.175,280.482
            c-1.271,3.439-4.531,5.572-8.004,5.572c-0.981,0-1.98-0.162-2.953-0.521l-127.693-47.13c-4.42-1.63-6.682-6.545-5.052-10.965
            s6.545-6.665,10.957-5.052l127.693,47.13C220.544,271.146,222.805,276.053,221.175,280.482z M221.175,229.282
            c-1.271,3.439-4.531,5.572-8.004,5.572c-0.981,0-1.98-0.162-2.953-0.521l-127.693-47.13c-4.42-1.63-6.682-6.545-5.052-10.965
            c1.63-4.412,6.545-6.673,10.957-5.052l127.693,47.13C220.544,219.946,222.805,224.853,221.175,229.282z M494.933,470.613
            c0,4.002-3.251,7.253-7.245,7.253H310.665l57.839-18.509c2.833-0.913,4.992-3.226,5.692-6.118c0.7-2.893-0.154-5.939-2.261-8.047
            l-27.068-27.059l28.1-28.1c3.337-3.336,3.337-8.738,0-12.066l-28.1-28.1l28.1-28.1c3.337-3.336,3.337-8.738,0-12.066l-28.1-28.1
            l28.1-28.1c3.337-3.337,3.337-8.738,0-12.066l-28.1-28.1l28.1-28.1c3.337-3.337,3.337-8.738,0-12.066l-28.1-28.1l28.1-28.1
            c3.337-3.337,3.337-8.738,0-12.066l-2.5-2.5h117.222c3.994,0,7.245,3.243,7.245,7.245V470.613z"
            />
          </g>
        </g>
      </svg>
    </div>
  )
}

export default EmptyPage
